module.exports = __webpack_public_path__ + "static/media/100_4.978e51b5.jpg";